import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, mergeApplicationConfig, provideExperimentalZonelessChangeDetection } from "@angular/core";
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routing";
import { httpErrorInterceptor } from "./modules/common-shared-module/interceptors/http-error.interceptor";
import { httpRequestInterceptor } from "./modules/common-shared-module/interceptors/http-request.interceptor";
import { httpSecurityInterceptor } from "./modules/common-shared-module/interceptors/http-security.interceptor";
import { spinnerInterceptor } from "./modules/common-shared-module/interceptors/spinner.interceptor";
import { ConfigService } from "./modules/common-shared-module/services/config/config.service";

import { FormlyProvider } from "./modules/common-shared-module/providers/formly/formly.provider";
import { MATProviders } from "./modules/common-shared-module/providers/material/material.provider";
import { QuillProvider } from "./modules/common-shared-module/providers/quill/quill.provider";



export function initLoggin(configService: ConfigService): () => Promise<void> {
    return () => configService.initLoggin()
}

const mainAppConfig: ApplicationConfig = {
    providers: [
        provideExperimentalZonelessChangeDetection(),
        provideHttpClient(
            withInterceptors([
                spinnerInterceptor,
                httpRequestInterceptor,
                httpSecurityInterceptor,
                httpErrorInterceptor
            ])
        ),
        MATProviders, // Base configure material providers //
        provideAnimations(),
        importProvidersFrom([
            FormlyProvider // Base to configure formly // 
        ]),
    ]
}

const customSPAConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        QuillProvider, // Base to configure quill (rich text editor) //
        {
            provide: APP_INITIALIZER,
            useFactory: initLoggin,
            deps: [ConfigService],
            multi: true
        },
    ]
}

const customWCConfig: ApplicationConfig = {
    providers: []
}

export const spaAppConfig: ApplicationConfig = mergeApplicationConfig(mainAppConfig, customSPAConfig);
export const wcAppConfig: ApplicationConfig = mergeApplicationConfig(mainAppConfig, customWCConfig);